import { render, staticRenderFns } from "./AddPlugin.vue?vue&type=template&id=b6d0567e&"
import script from "./AddPlugin.vue?vue&type=script&lang=js&"
export * from "./AddPlugin.vue?vue&type=script&lang=js&"
import style0 from "./AddPlugin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports